/**
 * Values sent on the `X-UI-AppName` request header that identify the calling
 * Nova UI / integration. PascalCase matches production wire format (do not
 * lowercase — MCP and all frontends already send these exact strings).
 *
 * Distinct from {@link AppsEnum} (custom-forms trigger targets: warehouse /
 * carrier / driver / api).
 */
export const uiAppName = {
  HELIOS: 'Helios',
  LUNA: 'Luna',
  COMET: 'Comet',
  CIRCE: 'Circe',
  JUNO: 'Juno',
  PHOTON: 'Photon',
  /** Opendock MCP identity (opendock-mcp outbound Neutron client). */
  JANUS: 'Janus',
  /** Fallback when the header is absent (API integrations). */
  UNKNOWN: 'Unknown'
} as const;

export type UiAppName = (typeof uiAppName)[keyof typeof uiAppName];
